import AutomatedTaskCardComponent from './AutomatedTaskCardComponent';
export default AutomatedTaskCardComponent;
